<template>
    <div class="unit-toggle"
        :class="{
            'checked': checked,
            'clickable': callback
        }"
        @click="() => callback ? callback() : null"
    >
        <img
            class="unit-toggle-img"
            :src="unitImage"
            :alt="unitType"
        />
        <span class="version-label">
            {{checked ? 'v2' : 'v1'}}
        </span>
    </div>
</template>

<script>
import { getAssetUrl } from '../../helpers/assets';

export default {
    name: 'UnitToggle',
    props: [
        'unitType',
        'disabledText',
        'enabledText',
        'checked',
        'callback',
    ],
    computed: {
        unitImage() {
            return getAssetUrl(`@/assets/units/${this.unitType.toLowerCase().replace('_nobility', '')}.png`);
        },
    },
};
</script>

<style lang="scss">
    @use "@/styles/styles.scss" as *;

    .unit-toggle {
        position: relative;

        &.clickable {
            cursor: pointer;
        }

        &.checked {

            .version-label {
                border-color: $green;
                color: $green;
            }
        }

        .unit-toggle-img {
            height: auto;
            max-height: 30px;
            max-width: 30px;
            width: auto;
        }

        .version-label {
            background: white;
            border-radius: 50%;
            border: 1px solid $gray;
            bottom: 0;
            color: $gray;
            padding: 2px 4px;
            position: absolute;
            right: 0;
            transform: translate(50%, 25%);
        }
    }
</style>
